import { render, staticRenderFns } from "./BasicGadget.vue?vue&type=template&id=de537712&scoped=true&"
import script from "./BasicGadget.vue?vue&type=script&lang=ts&"
export * from "./BasicGadget.vue?vue&type=script&lang=ts&"
import style0 from "./BasicGadget.vue?vue&type=style&index=0&id=de537712&lang=scss&scoped=true&"
import style1 from "./BasicGadget.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de537712",
  null
  
)

export default component.exports